<template>
  <v-app>
    <component v-if="networkStatus" :is="layout">
      <router-view/>
    </component>
    <div v-else class="offline-wrapper">
      <div class="offline-wrapper-content">
        <h2><v-icon left color="#fff">signal_wifi_off</v-icon> Nincs internet!!</h2>
        <p class="mt-2 mb-0">Kérlek kapcsold be a mobil interneted vagy menj közelebb a Wi-Fi hálózathoz.</p>
      </div>
    </div>
  </v-app>
</template>

<script>
const default_layout = "default";

export default {
  name: 'App',

  data () {
    return {
      networkStatus: true
    }
  },

  mounted () {
    this.$on('offline', () => {
      this.networkStatus = false
    }),

    this.$on('online', () => {
      console.log(window.navigator.mozConnection)
      this.networkStatus = true
    })
  },

  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout";
    },

    network() {
      return window.navigator.connection
    }
  },

};
</script>

<style lang="scss">
    .offline-wrapper {
      background: #000;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #efefef;
      flex-direction: column;

      .offline-wrapper-content {
        border: 2px solid #fff;
        text-align: center;
        max-width: 400px;
        padding: 20px;
      }
    }
</style>
